import { OptionPrice } from '../../lib/types/models/option-prices/option-price'
import { OptionPriceRequest } from '../../lib/types/models/option-prices/option-price-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateOptionPrice(data: UpdateInput<OptionPriceRequest>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.optionPrices.update.url, { id }))
    .patch<OptionPrice, Partial<OptionPriceRequest>>(rest)
}
